import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Spacer = styled.div `
  height: ${themeGet('spacing.md')};
`;
